import React from 'react';
import { CoreModuleStatus, CoreModuleIconState } from '../../models/CoreModels';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';



interface ModuleStatusProps {
    status?: CoreModuleStatus,
}

 const ModuleStatusSeverityIcon = (props: ModuleStatusProps) => {

    const { t } = useTranslation(['common', 'configuration']);

    const getIcon = (status: CoreModuleStatus | undefined) => {
        if (!status) {
            return null;
        }

        if (status.isInQuarantine) {
            return <span title={t('status.quarantine', { ns: 'common' })}> <FontAwesomeIcon icon="circle-radiation" className="icon_critical icon_active" /></span>;
        }

        switch (status.iconState) {
            case CoreModuleIconState.OK: return <span title={t('status.allOk', { ns: 'common' })} ><FontAwesomeIcon icon="check-circle" className="icon_ok icon_active" /></span>;
            case CoreModuleIconState.WARNING: return <span title={t('status.warning', { ns: 'common' })}><FontAwesomeIcon icon="exclamation-circle" className="icon_warning icon_active" /></span>;
            case CoreModuleIconState.ERROR: return <span title={t('status.error', { ns: 'common' })}><FontAwesomeIcon icon="times-circle" className="icon_error icon_active" /></span>;
            case CoreModuleIconState.CRITICAL: return <span title={t('status.critical', { ns: 'common' })}><FontAwesomeIcon icon="record-vinyl" className="icon_critical icon_active" /></span>;
            default: return null;
        }
    }
    return  getIcon(props.status)
}



export default ModuleStatusSeverityIcon;
